import {
  ChangeDetectionStrategy,
  Component,
  inject,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FeatureListItemComponent } from '@core/feature-preview/dialog/components/feature-list-item.component';
import { SearchFieldComponent } from '@shared/components/forms/fields/search-field/search-field.component';
import {
  FeatureCenterService,
  FeatureFilter,
} from '@core/feature-preview/dialog/services/feature-center.service';
import {
  TabComponent,
  TabsComponent,
  TabSelectionChange,
} from '@group24ag/flowkit';

@Component({
  selector: 'app-feature-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    FeatureListItemComponent,
    SearchFieldComponent,
    TabsComponent,
    TabComponent,
  ],
  styles: [
    `
      app-feature-list .flkTabs__content {
        padding: 0 !important;
      }
    `,
  ],
  template: `
    <div class="flex w-full gap-x-3 px-2 pt-4 pb-3">
      <app-search-field
        class="-mt-1.5 -ml-px w-full"
        label=""
        placeholder="Search by Name..."
        (searchEvent)="onSearch($event)" />

      <flk-tabs (selectionChange)="onSelectionChanged($event)">
        <flk-tab label="All" />
        <flk-tab label="Enabled" />
        <flk-tab label="Disabled" />
      </flk-tabs>
    </div>

    @if (!features().length) {
      <div class="flex size-full items-center justify-center">
        <p class="text--contrast-high text-lg">
          Currently there are no features in preview.
        </p>
      </div>
    } @else {
      <div class="grid grid-cols-2 gap-4 overflow-auto px-2 pt-1.5 pb-5">
        @for (feature of features(); track feature.feature.key) {
          <app-feature-list-item #item class="col-span-1" [feature]="feature" />
        }
      </div>
    }
  `,
})
export class FeatureListComponent {
  /** INJECTIONS **/
  /****/
  private readonly centerService = inject(FeatureCenterService);

  /** INPUTS **/
  /** Feature list component that displays a list of feature previews **/
  readonly features = this.centerService.features;

  /** PROPERTIES **/
  /****/
  private readonly _tabs = viewChild(TabsComponent);

  protected onSearch(searchTerm: string) {
    this.centerService.search = searchTerm;
  }

  protected onSelectionChanged($event: TabSelectionChange) {
    const tab = this._tabs()?.getTab($event.selectedIndex);

    let filter: FeatureFilter = 'all';
    if (tab?.label() === 'Enabled') filter = 'enabled';
    if (tab?.label() === 'Disabled') filter = 'disabled';

    this.filterFeatures(filter);
  }

  protected filterFeatures(filter: FeatureFilter) {
    this.centerService.filter = filter;
  }
}
